export const categories = [
  {
    id: 1,
    name: '恋爱漫画',
    slug: 'romance',
    description: '甜蜜心动，浪漫满屋',
    count: 3560,
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20aesthetic%20collage%2C%20soft%20pink%20and%20peach%20tones%2C%20couple%20silhouette%2C%20cherry%20blossoms%2C%20romantic%20atmosphere%2C%20dreamy%20background%2C%20delicate%20floating%20petals%2C%20warm%20glow%20effect%2C%20minimal%20composition%2C%20gentle%20and%20sweet%20vibe&width=800&height=600&seq=category-romance&orientation=landscape',
  },
  {
    id: 2,
    name: '奇幻冒险',
    slug: 'fantasy',
    description: '异世界的大门已打开',
    count: 2840,
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20world%2C%20magical%20castle%20and%20dragon%2C%20warm%20golden%20and%20amber%20lighting%2C%20epic%20adventure%20feel%2C%20mystical%20forest%20background%2C%20soft%20glow%20effects%2C%20fantasy%20landscape%2C%20dreamy%20but%20grand%20scale%2C%20detailed%20environment&width=800&height=600&seq=category-fantasy&orientation=landscape',
  },
  {
    id: 3,
    name: '动作热血',
    slug: 'action',
    description: '燃爆你的肾上腺素',
    count: 2150,
    image: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20dynamic%20scene%2C%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20warm%20fire%20tones%2C%20energy%20burst%20effects%2C%20intense%20composition%2C%20heroic%20vibe%2C%20cinematic%20framing%2C%20bold%20contrast%2C%20action%20genre%20feel&width=800&height=600&seq=category-action&orientation=landscape',
  },
  {
    id: 4,
    name: '悬疑推理',
    slug: 'mystery',
    description: '层层迷雾，步步惊心',
    count: 1680,
    image: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20atmosphere%2C%20dark%20alley%20with%20fog%2C%20detective%20theme%2C%20moody%20warm%20amber%20streetlight%2C%20shadowy%20figure%2C%20suspenseful%20composition%2C%20noir%20inspired%2C%20cinematic%20lighting%2C%20mysterious%20and%20tense%20vibe&width=800&height=600&seq=category-mystery&orientation=landscape',
  },
  {
    id: 5,
    name: '剧情生活',
    slug: 'drama',
    description: '人生百态，皆在画中',
    count: 1920,
    image: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%2C%20warm%20cozy%20cafe%20interior%2C%20soft%20natural%20light%20through%20window%2C%20everyday%20moments%2C%20gentle%20warm%20tones%2C%20relaxed%20atmosphere%2C%20modern%20Korean%20setting%2C%20comfortable%20and%20inviting%2C%20realistic%20style&width=800&height=600&seq=category-drama&orientation=landscape',
  },
  {
    id: 6,
    name: '搞笑日常',
    slug: 'comedy',
    description: '笑到停不下来',
    count: 2340,
    image: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20vibrant%20scene%2C%20colorful%20bright%20background%2C%20funny%20expressions%2C%20playful%20composition%2C%20warm%20yellow%20and%20orange%20tones%2C%20energetic%20atmosphere%2C%20cartoonish%20style%20elements%2C%20joyful%20and%20lively%20vibe%2C%20clean%20art&width=800&height=600&seq=category-comedy&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);